import { splitMentions } from "./mentions";

/**
 * Plain text with each `@Display Name` for the given names shown as a subtle
 * chip. Only names the server recorded as mentions are highlighted, and the
 * body is rendered as text nodes — never HTML.
 */
export function MentionText({ text, names }: { text: string; names: readonly string[] }) {
  return (
    <>
      {splitMentions(text, names).map((run, i) =>
        run.mention ? (
          <span key={i} data-testid="mention-chip" className="rounded bg-primary/10 px-0.5 font-medium text-primary">
            {run.text}
          </span>
        ) : (
          <span key={i}>{run.text}</span>
        ),
      )}
    </>
  );
}
